import { connect } from 'react-redux';
import ConfirmDeleteModal from './shared/confirm_delete_modal.jsx';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  deleteContentItemFromOrderedContentSection
} from 'zoomforth_codesbane_editor/action_creators/sections.ordered_content.js';
import { extractPlaintextFromHtmlString } from 'zoomforth_zfutils/dom_utils.js';

const mapStateToProps = (state, { section, contentItem }) => {
  const label = contentItem.accordion_data && extractPlaintextFromHtmlString(contentItem.accordion_data.label);

  return {
    title: 'Really delete item?',
    body: `You are about to delete the accordion item with label "${ label.length > 50 ? label.substring(0,50) + '...' : label }". This cannot be undone.`,
    confirmText: 'Delete Accordion Item',
    cancelText: 'Cancel'
  };
};

const mapDispatchToProps = (dispatch, { contentItem }) => (
  {
    onCancel: ()=> { 
      dispatch(closeModal()); 
    },
    onConfirm: ()=> { 
      dispatch(deleteContentItemFromOrderedContentSection(contentItem));
      dispatch(closeModal());
    }
  }
);

const ConfirmDeletAccordionItemModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmDeleteModal);

ConfirmDeletAccordionItemModal.editorModalName = 'ConfirmDeletAccordionItemModal';

export default ConfirmDeletAccordionItemModal;
